export default __webpack_public_path__ + "img/tab1and2_nav6-1-891cab56.png";